import { WagtailArticleAuthor } from '@/types';
import ArticleTags from '@components/ArticleTags';
import Image from 'next/image';
import Link from 'next/link';
import Insta from '../../styles/assets/images/Instagram_dark.svg';
import Linkedin from '../../styles/assets/images/Linkedin_dark.svg';
import Twitter from '../../styles/assets/images/Twitter_dark.svg';

type Props = { mobile: boolean; authors: WagtailArticleAuthor[]; tags: string[] };

function ArticleSidebar(props: Props) {
  const { authors, mobile, tags } = props;

  return (
    <div className='article-information container'>
      {authors.map(author => (
        <div key={authors.indexOf(author)} className='author wrapper'>
          <Image
            src={author.image.file}
            alt='Werkbank Logo'
            width={author.image.width}
            height={author.image.height}
            className='author__image'
            // blurDataURL="data:..." automatically provided
            // placeholder="blur" // Optional blur-up while loading
          />
          <div className='author__info'>
            <div className='article-information__heading author__info__name'>{author.name}</div>
            <div className='author__info__title'>{author.bio}</div>
          </div>
        </div>
      ))}

      {!mobile && <ArticleTags tags={tags} />}

      <div className='social-media wrapper'>
        <div className='article-information__heading social-media__heading'>Folgt uns:</div>
        <div className='social-media-icons'>
          <Link href='https://www.instagram.com/werkbank.de/' className='social-media__link'>
            <Insta />
          </Link>

          <Link href='https://www.linkedin.com/company/werkbank/' className='social-media__link'>
            <Linkedin />
          </Link>

          <Link href='https://twitter.com/DieWerkbank' className='social-media__link'>
            <Twitter />
          </Link>
        </div>
      </div>
    </div>
  );
}
export default ArticleSidebar;
